export const QUERY_KEYS = {
  account: 'account',
  accountSettings: {
    getAuthorizedConnections: 'authorizedConnections',
  },
  analytics: {
    getBusinessUpdates: 'businessUpdates',
    getCustomerInteractions: 'customerInteractions',
    getMetricsDataAvailability: 'metricsDataAvailability',
    getSearchAppearances: 'searchAppearances',
    getSearchAppearancesByMonth: 'searchAppearancesByMonth',
    getSearchAppearancesKeywords: 'searchAppearancesKeywords',
  },
  guestConnect: {
    firstPartyReview: {
      byId: 'getFirstPartyReviewById',
    },
  },
  reviewNotifications: {
    getAll: 'notifications',
  },
  reviews: {
    getAll: 'reviews',
    getById: 'getReviewById',
  },
  reviewLabels: {
    getAllLabels: 'getAllLabels',
  },
  reviewTemplates: {
    getTemplates: 'getTemplates',
    createTemplate: 'createTemplate',
  },
  listings: {
    getAll: 'listings',
    getById: 'listingDetails',
    getByStoreLocationId: 'getByStoreLocationId',
    getGoogleAccounts: 'getGoogleAccounts',
    getGoogleAccountsByVaultId: 'getGoogleAccountsByVaultId',
    getYelpAccountsByVaultId: 'getYelpAccountsByVaultId',
    getFacebookAccountsByVaultId: 'getFacebookAccountsByVaultId',
  },
  managedReviews: {
    prompts: {
      getResponseByReviewId: 'getResponseByReviewId',
    },
    settings: {
      getByReviewId: 'getByReviewId',
      getAll: 'reviewsSettings',
    },
    getAllTones: 'tones',
    availableFolders: 'managedReviewsAvailableFolders',
    availableStores: 'managedReviewsAvailableStores',
    quotas: {
      getByReviewId: 'getQuotaByReviewId',
    },
  },
  menus: {
    menus: {
      getAll: 'menus',
      getMenuById: 'menuById',
      getMenusByStoreLocationId: 'menusByStoreLocationId',
      updateMenu: 'updateMenu',
    },
    sections: { getAll: 'sections', getSectionById: 'sectionById' },
    items: { getAll: 'items', getItemById: 'itemById' },
    modifiers: { getAll: 'modifiers', getModifierById: 'modifierById' },
    choices: { getAll: 'choices', getChoiceById: 'choiceById' },
  },
  reviewsInsights: {
    getReviewAnalysis: 'reviewAnalysis',
    getSentimentAnalysis: 'sentimentAnalysis',
    getSentimentTrend: 'sentimentTrend',
    getTrendingKeywords: 'trendingKeywords',
    getKeywordPerformance: 'keywordPerformance',
    getLocationPerformance: 'locationPerformance',
    getStorePerformancesByRating: 'getStorePerformancesByRating',
    getTrendingThemes: 'trendingThemes',
    drawer: {
      getSummary: 'reviewsInsightsDrawerSummary',
      getReviews: 'reviewsInsightsDrawerReviews',
      getAISummary: 'reviewsInsightsDrawerAISummary',
    },
  },
  reviewsOverview: {
    awaitingReplies: 'awaitingReplies',
    publishersDistribution: 'publishersDistribution',
    ratingsOverview: 'ratingsOverview',
  },
  roles: {
    getAll: 'roles',
    getRolesByUser: 'rolesByUser',
  },
  permissions: {
    getAll: 'permissions',
    getPremiumFeatures: 'premiumFeatures',
  },
  storeLocations: {
    getAll: 'storeLocations',
    getStoreLocationsById: 'storeLocationById',
    categories: 'storeLocationCategories',
  },
  storeFolders: {
    getAll: 'storeFolders',
  },
  storeLocationCategories: {
    getAll: 'storeLocationCategories',
  },
  providerCategories: 'providerCategories',
  users: {
    getAll: 'users',
  },
  socialManagement: {
    pages: {
      getEnabledPages: 'getEnabledPages',
      getPagesByAuthorizedConnection: 'getPagesByAuthorizedConnection',
    },
    posts: {
      getById: 'getPostById',
      getPostDetailsById: 'getPostDetailsById',
      getPostInsightsById: 'getPostInsightsById',
      getAllPublished: 'getAllPublished',
      getAllScheduled: 'getAllScheduled',
      getAllDrafts: 'getAllDrafts',
    },
    storeListings: {
      getByPublisher: 'getStoreListingsByPublisher',
      getAppleCTAsByStoreListing: 'getAppleCTAsByStoreListing',
    },
  },
  widgets: {
    hour: 'hour-widgets',
    menu: 'menu-widgets',
    presets: 'widget-presets',
    all: 'all-widgets',
    reviewForm: 'review-form-widgets',
  },
  omni: {
    getProviderAttributes: 'getProviderAttributes',
  },
}
